import React from 'react';
import { styled, Box, LinearProgress, linearProgressClasses, Typography, useTheme } from '@mui/material';

export interface HDProgressBarTypes {
  benchMark: number,
  progressDescription: string,
  progress: number;
  primaryColor?: string,
  aboveBMBarColor?: string,
  belowBMBarColor?: string,
  progressNote?: string,
  height?: number,
  titleStyle?: Object,
  noteStyle?: Object,
  progressLegend?: any,
  withoutTheme?: any
}

const HDProgressBar = (props: HDProgressBarTypes) => {
  const theme = useTheme();
  let primaryColor: any, barColor: any = '';
  const progressParts = props.progressDescription.split('~');
  const textColor = (theme.palette.mode === 'light' && !props.withoutTheme) ? '#334255' : '#CCCCCC';


  const getBarColor = (progress:any, benchMark:any, belowBMBarColor:any, aboveBMBarColor:any, otherBelowBMBarColor:any, otherAboveBNBarColor:any) =>{
    if (progress < benchMark) {
      return belowBMBarColor || otherBelowBMBarColor;
    } else {
      return aboveBMBarColor || otherAboveBNBarColor;
    }
  };

  if (theme.palette.mode === 'light' && !props.withoutTheme) {
    primaryColor = (props.primaryColor) ? props.primaryColor : '#D6D9DB';
    barColor = getBarColor(props.progress, props.benchMark, props.belowBMBarColor, props.aboveBMBarColor, '#BC7D01', '#18768C');
  } else {
    primaryColor = (props.primaryColor) ? props.primaryColor : '#244052';
    barColor = getBarColor(props.progress, props.benchMark, props.belowBMBarColor, props.aboveBMBarColor, '#FEC350', '#2CDADA');
  }

  const BorderLinearProgress = styled(LinearProgress)(() => ({
    height: (props.height) ? props.height : 10,
    borderRadius: 100,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: primaryColor,
    },
    [`& .${linearProgressClasses.bar}`]: {
      backgroundColor: barColor,
    },
  }));

  const StyledTypoGraphy = styled(Typography)(() => ({
    fontFamily: 'Avenir',
    fontWeight: 300,
    fontSize: '16px',
    color: textColor,
    marginBottom: '16px',
  }));

  const PercentageSpan = styled(Box)(() => ({
    color: barColor
  }));

  const StyledNote = styled(Typography)(() => ({
    fontFamily: 'Avenir',
    fontSize: '16px',
    fontWeight: 300,
    color: textColor,
  }));

  const StyledLegend = styled(Box)(() => ({

  }));

  const noteWrapStyle = {
    display: 'flex',
    marginTop: '10px',
    justifyContent: 'space-between',
  };

  return (
    <Box>
      <StyledTypoGraphy sx={props.titleStyle}>
        {progressParts.map((part, idx) => {
          return part.match(/%/) ? (
            <PercentageSpan
              key={`percentage_${part}`}
              component='span'
            >
              {part}
            </PercentageSpan>
          ) : (
            part
          );
        })}
      </StyledTypoGraphy>
      <BorderLinearProgress variant='determinate' value={props.progress} />
      <Box sx={noteWrapStyle}>
        {props.progressNote &&
          <StyledNote sx={props.noteStyle}>{props.progressNote}</StyledNote>
        }

        {props.progressLegend &&
          <StyledLegend>{props.progressLegend}</StyledLegend>
        }
      </Box>
    </Box>
  );
};

export default HDProgressBar;